module.exports = {

    endFrameBg: {
        texture: '/img/partials/end-frame/background.jpg',
        scale: {
            x: '100%'
        }
    },

    endFrameSummary: {
        texture: '/img/partials/end-frame/summary-fr.png',
        scale: {
            x: '100%'
        },
        position: {
            x: '50%',
            y: '53.8%'
        },
        anchor: {
            x: 0.5,
            y: 0.5
        }
    }

};



// WEBPACK FOOTER //
// ./js/objects/partials/endFrame.js